import { CardShimmer } from "@components/index";
import DashboardCard from "../DashboardCard";
import { useDashbaordSectionData } from "./dashbaordSectionData";
import "./index.scss";

// Reusable Dashboard Section Component
const DashboardSection = ({
  section,
  cards,
  data,
  onCardClick,
  type = "stat", // 'stat', 'lob', or 'admin'
  loading = false,
}) => {
  const { getCardDataFromApiPath } = useDashbaordSectionData();

  if (!cards?.length) return null;

  const gridClass =
    type === "lob" ? "dashboard-section__cards-grid" : "home-page__stats-grid";

  // Get appropriate shimmer component based on card type and configuration
  const getShimmerComponent = (card, index) => {
    const key = `shimmer-${card.id || index}`;

    switch (type) {
      case "lob":
        return <CardShimmer type="lob" showTrend={true} key={key} />;
      case "admin":
        return <CardShimmer type="admin" showTrend={true} key={key} />;
      case "stat":
      default:
        const hasBreakdown = card.breakdown && card.breakdown.length > 0;
        const hasSubLabel = card.subLabel && card.getSubValue;

        return (
          <CardShimmer
            key={key}
            type="stat"
            showBreakdown={hasBreakdown}
            showSubLabel={hasSubLabel}
          />
        );
    }
  };

  return (
    <div className={type === "lob" ? "dashboard-section" : ""}>
      {section?.title && (
        <div className="dashboard-section__header">
          <h3 className="dashboard-section__title">{section.title}</h3>
        </div>
      )}
      <div className={gridClass}>
        {loading
          ? // Show appropriate shimmer cards when loading
            cards.map((card, index) => getShimmerComponent(card, index))
          : // Show actual cards when data is loaded
            cards.map((card) => {
              const cardData =
                type === "lob"
                  ? getCardDataFromApiPath(data, card.dataPath)
                  : data;

              return (
                <DashboardCard
                  key={card.id}
                  card={card}
                  data={cardData}
                  onClick={onCardClick}
                  type={type}
                />
              );
            })}
      </div>
    </div>
  );
};

export default DashboardSection;
